/** Set a URL query param. Accepts a single value or an array for multiple params with the same key. */
export function setUrlParameter(key, value) {
    const params = new URLSearchParams(window.location.search);
    params.delete(key);

    if (Array.isArray(value)) {
        for (const v of value) {
            params.append(key, v);
        }
    } else if (value != null && value !== '') {
        params.set(key, value);
    }

    window.history.replaceState({}, '', `${window.location.pathname}?${params}`);
}

/** Get a URL query param. Returns null, a string, or an array if multiple values exist. */
export function getUrlParameter(key) {
    const params = new URLSearchParams(window.location.search);
    const values = params.getAll(key);
    if (values.length === 0) return null;
    if (values.length === 1) return values[0];
    return values;
}
